import {isCursorInInlineSpace} from "../../state.js";
import {image} from "../../markdown.js";
import {simplePut} from '../../commands/changes.js';

export function pasteImage(alt, imageHref) {
  return ({state, dispatch}) => {
    if (isCursorInInlineSpace(state)) {
      simplePut(state, dispatch, image(alt, imageHref));
    } else {
      simplePut(state, dispatch, imageHref);
    }
  };
}

export function paste(string) {
  return ({state, dispatch}) => simplePut(state, dispatch, string);
}
